import clsx from 'clsx'

import styles from './Skeleton.module.scss'

function LoadingSkeleton({ className, ...rest }) {
  return <div className={clsx(styles.skeleton, className)} {...rest} />
}

export default LoadingSkeleton
